import React, { useContext, useState } from "react";
import ApiContext from "services/ApiContext";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";

function BankDetails(props) {
  const { setMessage, setVisible, shopData, shopID } = props;
  const Axios = useContext(ApiContext);
  const [smallNotice, setSmallNotice] = useState({
    open: false,
    field: "",
  });
  const [bankEdit, setBankEdit] = useState(false);

  const validationSchema = Yup.object().shape({
    BankName: Yup.string().required("Shop Status is required"),
    BankAccountNo: Yup.string().required("Fullname is required"),
  });

  const onShowAlert = () => {
    setVisible(true);
    window.setTimeout(() => {
      setVisible(false);
    }, 3000);
  };

  const { mutate, isLoading } = useMutation(
    (data) =>
      Axios.put(`/shop/${shopID}/banking`, {
        BankName: data.BankName,
        BankAccountNo: data.BankAccountNo,
      }),
    {
      onError: async (err) => {
        let msg = "";
        err.response.data.forEach((element) => {
          msg += `${element.MESSAGE}\n`;
        });
        setMessage({
          data: msg,
          type: "alert-danger",
        });
        onShowAlert();
      },

      onSuccess: async (res) => {
        setMessage({
          data: `${res.data.MESSAGE}`,
          type: "alert-success",
        });
        onShowAlert();
      },
    }
  );
  const formik = useFormik({
    initialValues: {
      BankName: shopData.data.BankName,
      BankAccountNo: shopData.data.BankAccountNo,
    },
    validationSchema,

    onSubmit: (data) => {
      setSmallNotice({ open: false, field: "" });
      mutate(data);
    },
  });

  const checkValid = (field) => {
    if (formik.values[field] === null || formik.values[field].trim() === "") {
      return "";
    }
    if (formik.errors[field]) {
      return "is-invalid";
    }
    return "is-valid";
  };

  // not display error message when value is nothing
  const errorExist = (field) => {
    if (formik.values[field] === null || formik.values[field].trim() === "") {
      return false;
    }
    return true;
  };

  return (
    <div>
      <Form>
        <Card className="card-dark">
          <CardHeader>
            <FormGroup className="pb-0">
              {!bankEdit ? (
                <>
                  <a
                    href="#edit"
                    className="float-right font-weight-normal"
                    onClick={() => setBankEdit(true)}
                  >
                    <i className="fa fa-pencil" aria-hidden="true" />
                    Edit
                  </a>
                  <CardTitle className="font-weight-bold" tag="h5">
                    Bank Details
                  </CardTitle>
                </>
              ) : (
                <CardTitle className="font-weight-bold" tag="h5">
                  Edit Bank Details
                </CardTitle>
              )}
            </FormGroup>
          </CardHeader>
          <CardBody>
            <Row>
              {bankEdit ? (
                <Col md="12">
                  <FormGroup>
                    <Label htmlFor="BankName">Bank Name</Label>
                    <Input
                      className={checkValid("BankName")}
                      name="BankName"
                      type="select"
                      onChange={formik.handleChange}
                      value={formik.values.BankName}
                    >
                      <option value="">Select one from below</option>
                      <option value="AFFIN BANK BERHAD">
                        AFFIN BANK BERHAD
                      </option>
                      <option value="ALLIANCE BANK MALAYSIA BERHAD">
                        ALLIANCE BANK MALAYSIA BERHAD
                      </option>
                      <option value="AMBANK (M) BERHAD">
                        AMBANK (M) BERHAD
                      </option>
                      <option value="BANK ISLAM MALAYSIA BERHAD">
                        BANK ISLAM MALAYSIA BERHAD
                      </option>
                      <option value="BANK KERJASAMA RAKYAT MALAYSIA BERHAD">
                        BANK KERJASAMA RAKYAT MALAYSIA BERHAD
                      </option>
                      <option value="BANK MUAMALAT (MALAYSIA) BERHAD">
                        BANK MUAMALAT (MALAYSIA) BERHAD
                      </option>
                      <option value="BANK SIMPANAN NASIONAL BERHAD">
                        BANK SIMPANAN NASIONAL BERHAD
                      </option>
                      <option value="CIMB BANK BERHAD">CIMB BANK BERHAD</option>
                      <option value="HSBC BANK MALAYSIA BERHAD">
                        HSBC BANK MALAYSIA BERHAD
                      </option>
                      <option value="HONG LEONG BANK BERHAD">
                        HONG LEONG BANK BERHAD
                      </option>
                      <option value="KUWAIT FINANCE HOUSE">
                        KUWAIT FINANCE HOUSE
                      </option>
                      <option value="MALAYAN BANKING BERHAD">
                        MALAYAN BANKING BERHAD
                      </option>
                      <option value="OCBC BANK (MALAYSIA) BERHAD">
                        OCBC BANK (MALAYSIA) BERHAD
                      </option>
                      <option value="PUBLIC BANK BERHAD">
                        PUBLIC BANK BERHAD
                      </option>
                      <option value="RHB BANK BERHAD">RHB BANK BERHAD</option>
                      <option value="STANDARD CHARTERED BANK (MALAYSIA) BERHAD">
                        STANDARD CHARTERED BANK (MALAYSIA) BERHAD
                      </option>
                      <option value="UNITED OVERSEAS BANK (MALAYSIA) BERHAD">
                        UNITED OVERSEAS BANK (MALAYSIA) BERHAD
                      </option>
                      <option value="Citibank Berhad">CITIBANK BERHAD</option>
                      <option value="AL RAJHI BANKING BERHAD">
                        AL RAJHI BANKING BERHAD
                      </option>
                      <option value="AGROBANK BERHAD">AGROBANK BERHAD</option>
                    </Input>
                    {errorExist("BankName") && (
                      <div className="text-danger">
                        {formik.errors.BankName ? formik.errors.BankName : null}
                      </div>
                    )}
                  </FormGroup>
                </Col>
              ) : (
                <Col md="12" className="pb-2">
                  <Label htmlFor="BankAccountNo">Bank Name</Label>
                  <div>{shopData.data.BankName}</div>
                </Col>
              )}
              <Col md="12">
                <FormGroup>
                  <Label htmlFor="BankAccountNo">AccountNo</Label>

                  <Input
                    className={`${!bankEdit ? "text-white" : null} ${
                      formik.errors.BankAccountNo ? "is-invalid" : "is-valid"
                    }`}
                    name="BankAccountNo"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.BankAccountNo}
                    plaintext={!bankEdit}
                    readOnly={!bankEdit}
                  />
                  <div className="text-danger">
                    {bankEdit && formik.errors.BankAccountNo
                      ? formik.errors.BankAccountNo
                      : null}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            {bankEdit && (
              <Row className="text-left pt-2 font-weight-bold justify-content-end">
                <Col sm="9">
                  <div className="text-center">
                    <Button
                      className="mt-3 button-dark-template"
                      disabled={
                        isLoading || Object.values(formik.errors).length > 0
                      }
                      loading={isLoading}
                      onClick={() => {
                        setSmallNotice({ open: true, field: "bank" });
                      }}
                    >
                      Save Edit
                    </Button>

                    <Button
                      className=" ml-3 mt-3 button-template"
                      onClick={() => setBankEdit(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      </Form>
      <Modal
        size="sm"
        isOpen={smallNotice.open}
        toggle={() => setSmallNotice({ open: false, field: "" })}
      >
        <ModalBody className="text-center">
          {smallNotice.field === "bank"
            ? "Confirm to Update Bank Details?"
            : null}
        </ModalBody>
        <ModalFooter>
          <div className="left-side" style={{ width: "48%" }}>
            <Button color="primary" type="submit" onClick={formik.handleSubmit}>
              Confirm
            </Button>
          </div>
          <div className="divider" />
          <div className="right-side" style={{ width: "48%" }}>
            <Button
              color="secondary"
              onClick={() => setSmallNotice({ open: false, field: "" })}
            >
              Cancel
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
}
BankDetails.propTypes = {
  shopData: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  setMessage: PropTypes.string.isRequired,
  setVisible: PropTypes.string.isRequired,
  shopID: PropTypes.string.isRequired,
};
export default BankDetails;
